/**
 * The Mini App language from a Telegram (or browser) language code. The whole
 * app exists in English and Portuguese; the prize-claim screens exist in all
 * five languages of the site (owner, 28.10); every other string falls back to
 * English. Ukrainian, Kazakh, Belarusian and Uzbek Telegram get Russian.
 */
export function pickLanguage(code: string | undefined | null): 'en' | 'pt' | 'es' | 'zh' | 'ru' {
  const c = (code || '').toLowerCase()
  if (c.startsWith('pt')) return 'pt'
  if (c.startsWith('es')) return 'es'
  if (c.startsWith('zh')) return 'zh'
  // Owner, 28.10: Russian screens also for Ukrainian, Kazakh, Belarusian and Uzbek.
  if (['ru', 'uk', 'kk', 'be', 'uz'].some((l) => c === l || c.startsWith(`${l}-`))) return 'ru'
  return 'en'
}
